import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Transformative AI Solutions for <span>Modern Enterprises</span>
            </h2>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult AI Solutions
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Intelligent Customer Engagement Navigator</h4>
                  <p>
                    Leverage AI-driven conversational agents for intuitive
                    customer interactions and bespoke support solutions.
                    Automate customer service workflows to increase engagement,
                    streamline issue resolution, and drive exceptional
                    satisfaction.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Advanced Knowledge Intelligence Navigator</h4>
                  <p>
                    Harness the power of generative AI for advanced knowledge
                    management and semantic search. Uncover valuable insights,
                    expedite information retrieval, and facilitate data-driven
                    decision-making across your organization.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Process Automation & Optimization</h4>
                  <p>
                    Implement AI-powered automation to refine operational
                    workflows, reduce manual interventions, and boost overall
                    efficiency. Achieve process optimization, elevate
                    productivity, and maintain competitive advantage with
                    intelligent automation solutions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Accelerated Development Navigator</h4>
                  <p>
                    Empower your development teams with AI-enhanced tools
                    designed to speed up development cycles and elevate code
                    quality. Foster innovation, simplify complex workflows, and
                    enhance team collaboration through AI-driven development
                    resources.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Smart Data Engineering Navigator</h4>
                  <p>
                    Optimize data pipelines with AI-recommended best practices
                    and automated solutions. Improve data processing efficiency,
                    ensure accuracy, and address common data engineering
                    challenges with cutting-edge AI technology.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
